import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdditionalDependencies = (additionalDependencies) => {
  const dependenciesBySpec = {}
  const dependenciesByType = {}

  if (Array.isArray(additionalDependencies)) {
    additionalDependencies.forEach(dependency => {
      if (dependency.dependent) {
        const depObj = {
          dependent: dependency.dependent,
          dependentType: dependency.dependentType,
          dependentRatio: dependency.dependentRatio,
          dependentValues: dependency.dependentValues,
          type: dependency.type
        }

        if (!Array.isArray(dependenciesBySpec[dependency.dependent])) {
          dependenciesBySpec[dependency.dependent] = [depObj]
        } else {
          dependenciesBySpec[dependency.dependent].push(depObj)
        }

        if (!dependenciesByType[dependency.type]) {
          dependenciesByType[dependency.type] = { hide: null, show: null }
        }

        if (!dependenciesByType[dependency.type][dependency.dependentType]) {
          dependenciesByType[dependency.type][dependency.dependentType] = {
            [dependency.dependent]: dependency.dependentValues
          }
        } else {
          dependenciesByType[dependency.type][dependency.dependentType][dependency.dependent] = dependency.dependentValues
        }
      }
    })
  }

  return {
    type: actionTypes.SET_CATEGORY_ADDITIONAL_DEPENDENCIES,
    payload: {
      bySpec: dependenciesBySpec,
      byType: dependenciesByType
    }
  }
}
